export const isAcceptanceTest = () => {
  return !!window.navigator.webdriver;
};

// prerendering is only available in Chromium
export type DocumentWithPrerendering = Document & { prerendering?: boolean };

export const isPrerendering = () => {
  return !!(window?.document as DocumentWithPrerendering)?.prerendering;
};
